export default __webpack_public_path__ + "static/media/Entypa_Asfalias.b54b3df6.jpg";